export const orange = '#ff8402';
export const dark_grey = 'rgb(80, 80, 80)';
export const grey = 'rgb(140, 140, 140)';
export const light_grey = 'rgb(211,211,211)';
export const very_light_grey = 'rgb(240, 240, 240)';
export const green = '#57F298';
export const blue = 'rgba(0, 0, 255, 0.2)';
export const pale_red = 'rgba(255, 0, 0, 0.2)'
export const horrible_orange = 'rgba(255, 206, 12, 0.19)'
export const purple = '#6E2CD4'